import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Arg, Entity, Field, Query } from '@adornis/baseql/decorators.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Participation } from './Participation.js';
import { Einzelberatung } from './einzelberatung.js';

@Entity()
export class ParticipationEinzelberatung extends Participation<Einzelberatung> {
  static override _class = 'ParticipationEinzelberatung';

  @validate(nonOptional())
  @Field(type => ID)
  timeslotID!: ID;

  public override async timespan() {
    const product = await getByID<typeof Einzelberatung>(
      Einzelberatung,
      this.productID as string,
    )({ slots: { _id: 1, start: 1, end: 1, isNonBlocking: 1 } });

    if (!product) throw new Error('invalid product instance');

    const timeslot = product.slots.find(slot => slot._id === this.timeslotID);
    if (!timeslot) throw new Error('timeslot not found');
    return [timeslot];
  }

  @Query(type => [ParticipationEinzelberatung])
  static getParticipationsEinzelberatungByProductID(@Arg('productID', type => String) productID: string) {
    return async (gqlFields: BaseQLSelectionSet<ParticipationEinzelberatung>) => {
      const collection = await getCollection<ParticipationEinzelberatung>(ParticipationEinzelberatung._class);
      const result = await collection.find<ParticipationEinzelberatung>({ productID }).toArray();
      return result;
    };
  }
}
